export default function dateExists(date) {
	return Boolean(date) && Boolean(date.date);
}
